import request from '../utils/request'
import { getStoredLatLng } from '../utils/geolocation'
import { getPreviewValidationFlag, normalizeOrderProductPrices } from '../utils/price'

import service from '../config/services';

const { domain: { store } } = service;

//获取首页商户信息
export function getRelateStoreInfoModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/getRelateStore.do`,
    method: 'get',
    params: data
  })
}

//菜单页商户信息
export function getIndexInfoModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/home.do`,
    method: 'get',
    params: data
  })
}

//注册
export function registerModel(data) {
  return request({
    url: `${store}/store-web/api/customer/member/register.do`,
    method: 'post',
    data
  })
}

//memberinfo
export function getMemberInfoModel(data) {
  return request({
    url: `${store}/store-web/api/customer/member/info.do`,
    method: 'get',
    params: data
  })
}
//活动列表
export function getActivityModel(data) {
  return request({
    url: `${store}/store-web/api/activity/getActivity.do`,
    method: 'get',
    params: data
  })
}

//活动列表2.0
export function getActivityNextModel(data) {
  return request({
    url: `${store}/store-web/api/activity/getActivityNext.do`,
    method: 'get',
    params: data
  })
}

//修改用户信息
export function modifyUserInfoModel(data) {
  return request({
    url: `${store}/store-web/api/customer/member/modifyInfo.do`,
    method: 'post',
    data
  })
}

//下单（lat / lng 优先用入参，否则用 localStorage 中首页/订单页缓存的定位）
export function submitOrderModel(data) {
  const stored = getStoredLatLng();
  const pick = (v, fallback) =>
    v != null && String(v).trim() !== '' ? v : fallback;
  const payload = normalizeOrderProductPrices({
    ...data,
    lat: pick(data?.lat, stored.lat),
    lng: pick(data?.lng, stored.lng),
  });
  return request({
    url: `${store}/store-web/api/customer/order/order.do`,
    method: 'post',
    data: payload,
  });
}

//订单列表
export function orderListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/order/query.do`,
    method: 'get',
    params: data
  })
}

//根据订单id获取订单详情
export function getOrderDetailModel(data) {
  return request({
    url: `${store}/store-web/api/customer/order/detail.do`,
    method: 'get',
    params: data
  })
}



//语言列表
export function getLanListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/language.do`,
    method: 'get',
    params: data
  })
}

//获取商户信息
export function getStoreInfoByIdModel(data) {
  return request({
    // url: `${store}/store-web/api/customer/store/getById.do`,
    url: `${store}/store-web/api/customer/store/getStoreInfo.do`,
    method: 'get',
    params: data
  })
}

//下单预判。第三方计价时由调用方传入 isPreview: false
export function judgeOrderModel(data, options = {}) {
  const isPreview = options.isPreview !== undefined
    ? options.isPreview
    : getPreviewValidationFlag(data?.products)
  return request({
    url: `${store}/store-web/api/customer/order/preview.do`,
    method: 'post',
    params: {
      isPreview
    },
    data
  })
}

//获取活动分类数据
export function getHomeCategoryModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/homeCategory.do`,
    method: 'get',
    params: data
  })
}

//获取首页商品
export function getHomeProductModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/homeProduct.do`,
    method: 'get',
    params: data
  })
}

//获取首页商品 2.0
export function getHomeProductNextModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/homeProductNext.do`,
    method: 'get',
    params: data
  })
}



//获取商户图标
export function getIconByStoreIdModel(data) {
  return request({
    url: `${store}/store-web/api/customer/store/getIconROByStoreId.do`,
    method: 'get',
    params: data,
    hideError: true,
  })
}

//获取产品菜单
export function getProductMenuModel(data) {
  return request({
    url: `${store}/store-web/api/customer/product/getProductMenu.do`,
    method: 'get',
    params: data
  })
}


//上传图片
export function uploadImageModel(data) {
  return request({
    url: `${store}/store-web/api/customer/order/uploadImage.do`,
    method: 'post',
    data
  })
}

//获取文章列表
export function getArticleByStoreIdModel(data) {
  return request({
    url: `${store}/store-web/api/customer/service/getByStoreId.do`,
    method: 'get',
    params: data
  })
}

//获取优惠券
export function getCouponModel(data) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getCoupon.do`,
    method: 'get',
    params: data
  })
}

//获取优惠券规则详情
export function getCouponRuleDetailModel(data, hideError = true) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getCouponRuleDetail.do`,
    method: 'get',
    params: data,
    hideError
  })
}

//获取优惠券规则
export function getCouponRuleModel(data, hideError = true) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getCouponRule.do`,
    method: 'get',
    params: data,
    hideError
  })
}

//获取优惠券列表
export function getCouponListModel(data, hideError = true) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getCouponList.do`,
    method: 'get',
    params: data,
    hideError
  })
}
//获取优惠券列表
export function getMyCouponListModel(data, hideError = true) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getMyCouponList.do`,
    method: 'get',
    params: data,
    hideError
  })
}

//获取优惠券数量
export function getMyCouponCountModel(data, hideError = true) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getMyCouponCount.do`,
    method: 'get',
    params: data,
    hideError
  })
}

//领取优惠券
export function receiveCouponModel(data) {
  return request({
    url: `${store}/store-web/api/customer/coupon/receiveCoupon.do`,
    method: 'get',
    params: data
  })
}


//获取发现列表
export function getDiscoverListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/discover/discoverList.do`,
    method: 'get',
    params: data
  })
}

///api/customer/service/list.do
export function getServiceList(data) {
  return request({
    url: `${store}/store-web/api/customer/service/list.do`,
    method: 'get',
    params: data
  })
}

//获取通知列表
export function getNotificationListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/msg/list.do`,
    method: 'get',
    params: data
  })
}

//获取产品详情
export function getProductDetailModel(data) {
  return request({
    url: `${store}/store-web/api/customer/product/productDetail.do`,
    method: 'get',
    params: data
  })
}

//获取我的评价列表
export function getMyRatingListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/rating/get/my/list.do`,
    method: 'get',
    params: data
  })
}


//客户端-将所有未读消息设为已读
export function setMsgReadAllModel(data) {
  return request({
    url: `${store}/store-web/api/customer/msg/viewAll.do`,
    method: 'get',
    params: data
  })
};

//客户端-将指定未读消息设为已读 (单个)
export function setSingleMsgReadModel(data) {
  return request({
    url: `${store}/store-web/api/customer/msg/view.do`,
    method: 'get',
    params: data
  })
};

//获取推荐商品列表
export function getRecommendProductListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/product/getRecommendProductList.do`,
    method: 'get',
    params: data
  })
}

//获取pdf文件
export function getPdfFileModel(data, getUrl = false) {
  if (getUrl) {
    return `${store}/store-web/api/customer/store/getPdfFile.do?fileUrl=${data.fileUrl}`
  }
  return request({
    url: `${store}/store-web/api/customer/store/getPdfFile.do`,
    method: 'get',
    params: data
  })
}


//领取所有优惠券
export function getAllCouponListModel(data) {
  return request({
    url: `${store}/store-web/api/customer/coupon/getAllCouponList.do`,
    method: 'get',
    params: data
  })
}

//活动详情
export function getActivityDetailModel(data) {
  return request({
    url: `${store}/store-web/api/activity/getDetail.do`,
    method: 'get',
    params: data
  })
}

//发起支付
export function initOrderPayModal(data) {
  return request({
    url: `${store}/store-web/api/customer/orderPay/initPay.do`,
    method: 'get',
    params: data
  })
}

//文章详情
export function getServiceInfoModal(data) {
  return request({
    url: `${store}/store-web/api/customer/service/getServiceInfo.do`,
    method: 'get',
    params: data
  })
}

//添加行为统计
export function addBehaviorstatsModel(data) {
  return request({
    url: `${store}/store-web/api/behaviorStats/addBehaviorStats.do`,
    method: 'post',
    data,
    hideError: true,
  })
}

//获取推荐商品列表
export function getAIRecommendedProductsModel(data) {
  return request({
    url: `${store}/store-web/api/customer/recommendation/getRecommendedProduct.do`,
    method: 'get',
    params: data
  })
}
